'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatePersistence = function () {
    function StatePersistence(storageKey, state, storage, logger) {
        (0, _classCallCheck3.default)(this, StatePersistence);

        this.storageKey = storageKey;
        this.state = state;
        this.storage = storage;
        this.logger = logger;
        this.isPersisting = false;
        this.includeBuffers = true;

        this.state.persistence = this;
    }

    (0, _createClass3.default)(StatePersistence, [{
        key: 'loadStateIfExists',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var storedState;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.storageKey) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _context.next = 4;
                                return this.storage.get(this.storageKey);

                            case 4:
                                storedState = _context.sent;

                                if (storedState) {
                                    if (this.logger) {
                                        this.logger('Importing state', storedState);
                                    }

                                    this.state.importState(storedState);
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadStateIfExists() {
                return _ref.apply(this, arguments);
            }

            return loadStateIfExists;
        }()
    }, {
        key: 'watchStateForChanges',
        value: function watchStateForChanges() {
            var _this = this;

            if (!this.storageKey) {
                return;
            }

            var debouncedSaveState = _lodash2.default.debounce(function () {
                if (_this.logger) {
                    _this.logger('State updated, setting localStorage');
                }

                _this.storage.set(_this.storageKey, _this.state.exportState(_this.includeBuffers));
            }, 1000);

            this.state.$watch('networks', debouncedSaveState, { deep: true });
            this.state.$watch('user_settings', debouncedSaveState, { deep: true });

            var bufferWatchers = [];
            var watchBuffers = function watchBuffers() {
                bufferWatchers.forEach(function (w) {
                    return w();
                });
                bufferWatchers = [];

                _this.state.networks.forEach(function (network) {
                    var bufferNames = network.buffers.map(function (b) {
                        return b.name;
                    }).join(',');

                    network.buffers.forEach(function (buffer) {
                        var unwatch = _this.state.$watch(function () {
                            var val = (0, _stringify2.default)([bufferNames, buffer.name, buffer.settings, buffer.joined, buffer.enabled, buffer.last_read]);

                            return val;
                        }, debouncedSaveState);

                        bufferWatchers.push(unwatch);
                    });
                });

                setTimeout(watchBuffers, 2000);
            };

            setTimeout(watchBuffers, 2000);

            this.isPersisting = true;
        }
    }, {
        key: 'forgetState',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.state.resetState();
                                _context2.next = 3;
                                return this.storage.set(this.storageKey, null);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function forgetState() {
                return _ref2.apply(this, arguments);
            }

            return forgetState;
        }()
    }]);
    return StatePersistence;
}();

exports.default = StatePersistence;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["StatePersistence"]
window._kiwi_exports.libs.StatePersistence = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/StatePersistence.js
// module id = tewY
// module chunks = 1